import {Banner} from '@primer/react'
import {forwardRef} from 'react'

export const ServerErrorFormBanner = forwardRef(ServerErrorFormBannerWithRef)

function ServerErrorFormBannerWithRef({children}: React.PropsWithChildren, ref: React.ForwardedRef<HTMLDivElement>) {
  return (
    <Banner
      title="Server error"
      hideTitle
      variant="critical"
      data-testid="server-error-banner"
      ref={ref}
      tabIndex={0}
      description={children}
    />
  )
}

try{ ServerErrorFormBanner.displayName ||= 'ServerErrorFormBanner' } catch {}
try{ ServerErrorFormBannerWithRef.displayName ||= 'ServerErrorFormBannerWithRef' } catch {}